import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EnumScales } from '@library/store/measures/measures.interface';
import { UtilsService } from '@library/utils/services/utils.service'
import { scalesCrowdinKeys } from './scales.constant'


@Component({
  selector: 'app-scales',
  templateUrl: './scales.component.html',
  styleUrls: ['./scales.component.scss']
})
export class ScalesComponent {

  EnumScales = EnumScales;

  scales = {
    [EnumScales.DAY]: scalesCrowdinKeys[0],
    [EnumScales.WEEK]: scalesCrowdinKeys[1],
    [EnumScales.MONTH_DAILY]: scalesCrowdinKeys[2],
    [EnumScales.YEAR]: scalesCrowdinKeys[3],
  };

  constructor(public utilsService: UtilsService) {
  }

  @Input() selectedScale: EnumScales;
  @Output() selectedScaleChange = new EventEmitter<EnumScales>();
  @Input() disabled = false;

  get selectedScaleIndex() {
    return scalesCrowdinKeys.findIndex(s => s.value === this.selectedScale);
  }

}
